import React, { useCallback, useEffect, useState } from "react";
import eye from "../../../assets/images/ct/they-know-eye.png";
import line from "../../../assets/images/ct/question/que-line.png";
import dice from "../../../assets/images/ct/question/dice-arrow.png";
import checkIcon from "../../../assets/images/ct/question/check-icon.png";
import NonActivePlayerQuestion from "../components/NonActivePlayerQuestion";
import ActivePlayerQuestion from "../components/ActivePlayerQuestion";
import _ from "lodash";
const CTQuestion = ({
  roomId,screens,
  isActivePlayer,
  isReaderPlayer, 
  answers,
  currentPlayer,
  category,
  correct_answer,
  question,
  dicedata,buzzer_sound,default_audio_effect
}) => {
  useEffect(() => {
    if (
      isActivePlayer || isReaderPlayer &&
      !_.isEmpty(default_audio_effect) 
   
    ) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer,isReaderPlayer, default_audio_effect]);

  return isActivePlayer ? (
    <ActivePlayerQuestion
    screens={screens}
      answers={answers}
      category={category}
      prompt={question}
      roomId={roomId}
      currentPlayer={currentPlayer}
      dicedata={dicedata}
    />
  ) : (
    <NonActivePlayerQuestion
    screens={screens}
      isReaderPlayer={isReaderPlayer}
      answers={answers}
      category={category}
      question={question}
      dicedata={dicedata}
      correct_answer={correct_answer}
    />
  );
};

export default CTQuestion;
